import React, { useState, useCallback  } from "react";
// reactstrap components
import {
    FormGroup,
    Label,
    Button,
    Input,
    Container,
    Row,
    Col,
    Modal,
    ModalBody,
    Form,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";
import Datetime from 'react-datetime';
// core components
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import { handleResponse, authHeader } from '_helpers';
import IndexNavbar from "components/Navbars/TSNavbar";
import IndexHeader from "components/Headers/IndexHeader2.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import TSUpload from "components/Forms/TSUpload2.js";
import TSText from "components/Forms/TSText.js";
import TSSelect from "components/Forms/TSSelect.js";

import Webcam from "react-webcam";


import { useDropzone } from 'react-dropzone'
import 'assets/css/react-datetime.css'
import Resizer from 'react-image-file-resizer';

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
};

//function TelePage2() {
const TelePage2 = (props) => {
    const userID = (props.match.params.userID !== undefined) ? props.match.params.userID : null;
    const [dateFocus, setDateFocus] = useState(false);
    const [errMsg, setErrMsg] = useState(false);
    const [modalError, setModalError] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [modalNote, setModalNote] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");


    const [isOpenCam, setIsOpenCam] = useState(false);
    const webcamRef = React.useRef(null);
    const [imgSrc, setImgSrc] = React.useState(null);

        React.useEffect(() => {
            fetch('/api/v1/user/network/' + userID, {
                method: 'GET',
                headers: authHeader()
            })
            .then(handleResponse)
            .then(
                (result) => {
                    console.log(result)
                    setFullName(result.firstName + ' ' + result.lastName)

                    fetch('/api/v1/user/role/N_DOCTOR', {
                        method: 'GET',
                        headers: authHeader()
                    })
                        .then(handleResponse)
                        .then(
                            (resultDoctor) => {
                                setParentOption(resultDoctor)
                            },
                            (error) => {
                                alert(error);
                            }
                        );
                },
                (error) => {
                    alert(error);
                }
            );




        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");

        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };  
    }, []);


    const [parentID, setParentID] = useState('');
    const [parentOption, setParentOption] = useState([]);
    const [ServiceType, setType] = useState(3);
    const [ServiceTypeText, setTypeText] = useState("");
    const [AppointDatetime, setDate] = useState("");
    const [Phone, setPhone] = useState("");
    const [LineID, setLine] = useState("");
    const [ShippingAddress, setAddress] = useState("");
    const [DefAddress, setDefAddress] = useState("");
    const [Description, setDescription] = useState("");
    const [FullName, setFullName] = React.useState("");
    const [isCheckedAddress, setIsCheckedAddress] = React.useState(false);
    const [files, setFiles] = useState([]);


    var fileTxt = "";

    var moment = require('moment');
    require('moment/locale/th');


    //-----Capture Webcam
  
    const capture = React.useCallback(() => {
        const imageSrc = webcamRef.current.getScreenshot();
        const blob = dataURLtoBlob(imageSrc);
        setFiles(f => [...f, Object.assign(blob, { preview: URL.createObjectURL(blob) })])
    }, [webcamRef, setImgSrc]);

    const dataURLtoBlob = (dataurl) => {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }


    const startCam = () => {
        setIsOpenCam(true);
    }
    const captureThenClose = () => {
        capture();
        let stream = webcamRef.current.stream;
        const tracks = stream.getTracks();
        tracks.forEach(track => track.stop());
        setIsOpenCam(false);
    }

    const stopCam = () => {
        let stream = webcamRef.current.stream;
        const tracks = stream.getTracks();
        tracks.forEach(track => track.stop());
        setIsOpenCam(false);
    }



    //-----Capture Webcam

    const handleClear = (evt) => {
        evt.preventDefault();
        setFiles([]);
    }
    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: acceptedFiles => {
            acceptedFiles.map(file =>
                //console.log(URL.createObjectURL(file))
                setFiles(f => [...f, Object.assign(file, { preview: URL.createObjectURL(file) })])
                //setFiles(f => [...f, Object.assign(file, { preview: URL.createObjectURL(file) })])
            )    
            /*
            setFiles(
                
                acceptedFiles.map(file =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file)
                    })
                )

            );
            */
        },
        
    });

    const thumbs = files.map(file => (
        <div style={thumb} key={file.name}>
            <div style={thumbInner}>
                <img
                    src={file.preview}
                    style={img}
                />
            </div>
        </div>
    ));

    async function uploadWithJSON(file) {
        

        const toBase64 = file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });

        const toBase64Resize = (file2) => new Promise(resolve => {
            var compressType;

            if (file2.type == 'image/jpeg')
                compressType = 'JPEG';
            else if (file2.type == 'image/png')
                compressType = 'PNG';
            else if (file2.type == 'image/webp')
                compressType = 'WEBP';

            Resizer.imageFileResizer(file2, 1000, 1000, compressType, 100, 0,
                uri => {
                    resolve(uri);
                },
                'base64'
            );
        });
        //console.log(file)

        const data = {
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type,
            fileBase64: await toBase64Resize(file),
            //fileBase64: await toBase64(file),
        }

        return await data;
    }


    const handleServiceType = (sType) => {
        setType(sType);
        setTypeText((sType==1)?'พบแพทย์':'รับยา')
    }


    const handleSubmit = (evt) => {
        evt.preventDefault();

        console.log(files)

        var cntErr = 0;
        var errMsg = '';


        if (Description == null || Description == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุอาการเบื้องต้น';
        }

        if (parentID == null || parentID == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุแพทย์ผู้ปรึกษา';
        }

        /*
        if (!isCheckedAddress && (ShippingAddress == null || ShippingAddress == '')) {
            cntErr += 1;
            errMsg = 'กรุณาระบุที่อยุ่จัดส่งยาทางไปรษณีย์';
        }

        if (isCheckedAddress && (DefAddress == null || DefAddress == '')) {
            cntErr += 1;
            errMsg = 'กรุณาระบุที่อยุ่จัดส่งยาทางไปรษณีย์';
        }
      

        if (Phone == null || Phone == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุหมายเลขโทรศัพท์';
        }
          */

        if (!moment(AppointDatetime).isValid()) {
            cntErr += 1;
            errMsg = 'กรุณาระบุวันที่ต้องการรับบริการ';
        }
        else {
            /*
            if (ServiceType == 1 && moment(AppointDatetime).format("DD/MM/YYYY") == moment(new Date()).format("DD/MM/YYYY") && moment().hour() >= 11) {
                cntErr += 1;
                errMsg = 'การพบแพทย์กรุณาทำรายการก่อน 11.00 น. หรือ เลือกวันถัดไป';
            } else if (ServiceType == 2 && moment(AppointDatetime).format("DD/MM/YYYY") == moment(new Date()).format("DD/MM/YYYY") && moment().hour() >= 15) {
                cntErr += 1;
                errMsg = 'การรับยาเดิมกรุณทำรายการก่อน 15.00 น. หรือ เลือกวันถัดไป';
            }
            */
        }
        /*
        if (ServiceType == null || ServiceType == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุความต้องการ พบแพทย์หรือรับยาต่อเนื่อง';
        }
        */
        /*
        if (ServiceType == 1 && files.length < 4) {
            cntErr += 1;
            errMsg = 'การพบแพทย์กรุณาแนบรูปอาการอย่างน้อย 4 รูป';
        }
        */
  
        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        }
        else {
            setModal2(true);
        }     
    }

    const handleConfirm = (evt) => {
        evt.preventDefault();
        
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

        //alert(currentUser.fullName);

        //alert(`Submitting Type ${ServiceType} Date ${AppointDatetime} LineID ${LineID}, Phone ${Phone}, ShippingAddress ${ShippingAddress}, Description ${Description} `)


        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            },
            body: JSON.stringify({
                "userID": userID,
                "parentID": parentID,
                "serviceType": ServiceType,
                "appointDatetime": AppointDatetime,
                "description": Description,
            })
            //"lineID": LineID,
            // "phone": Phone,
            // "shippingAddress": (isCheckedAddress) ? DefAddress : ShippingAddress/*ShippingAddress*/,

        };

        fetch('/api/v1/consult', requestOptions)
            .then(handleResponse)
            .then(
                (result) => {
                    //console.log(result);

                    //console.log(files);
                    var totalFile = files.length;
                    if (totalFile > 0) {
                        files.map((file, index) => {
                            const prom = uploadWithJSON(file);
                            Promise.resolve(prom).then((e) => {
                                //console.log(e);
                                const reqOpt = {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json-patch+json',
                                        'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                                    },
                                    body: JSON.stringify({
                                        "teleID": result.data.teleID,
                                        "fileName": e.fileName,
                                        "fileCategoryID": 0,
                                        "fileType": e.fileType,
                                        "fileSize": e.fileSize,
                                        "fileBase64": e.fileBase64,
                                    })
                                };

                                fetch('/api/v1/tele/upload', reqOpt)
                                    .then(handleResponse)
                                    .then(
                                        (result) => {
                                            //console.log(result);
                                            //alert(result.data.fileID)
                                            if (index == (totalFile - 1)) {
                                                setModal2(false)
                                                setModalNote(true)
                                                /*
                                                if (liff.isInClient()) {
                                                    liff.sendMessages([{
                                                        'type': 'text',
                                                        'text': `#ยืนยันการลงทะเบียน${ServiceTypeText}  - ${currentUser.fullName} ${AppointDatetime}` 
                                                    }]).then(function () {
                                                        liff.closeWindow();
                                                    }).catch(function (error) {
                                                        window.alert('Error sending message: ' + error);
                                                    });


                                                } else {
                                                    const { from } = props.location.state || { from: { pathname: "/home" } };
                                                    props.history.push(from);
                                                }
                                                */
                                            }
                                        },
                                        (error) => {
                                            console.log(error);
                                            alert(error)
                                        }
                                    )
                            });
                        });
                    }
                    else {
                        setModal2(false)
                        setModalNote(true)
                        /*
                            if (liff.isInClient()) {

                                liff.sendMessages([{
                                    'type': 'text',
                                    'text': `#ยืนยันการลงทะเบียน${ServiceTypeText}  - ${currentUser.fullName} ${AppointDatetime}`
                                }]).then(function () {
                                    liff.closeWindow();
                                }).catch(function (error) {
                                    window.alert('Error sending message: ' + error);
                                });


                            } else {
                                const { from } = props.location.state || { from: { pathname: "/home" } };
                                props.history.push(from);
                            }
                            */
                    }
                    //setId(result.data.teleID);
                    //setModal2(true);

                    //bug อยู่  ต้องรอให้ upload เสร็จก่อน ถึงจะปิดจอ
                    /*
                    if (liff.isInClient()) {

                        liff.sendMessages([{
                            'type': 'text',
                            'text': '#ยืนยันการจอง'
                        }]).then(function () {
                            //window.alert('Message sent');
                        }).catch(function (error) {
                            window.alert('Error sending message: ' + error);
                        });

                        //liff.closeWindow();
                    } else {
                        const { from } = props.location.state || { from: { pathname: "/home" } };
                        props.history.push(from);
                    }
                    */
                },
                (error) => {
                    setIcon("far fa-question-circle");
                    setErrMsg(error);
                    setModal2(false);
                    setModalError(true);
                }
            )

    }

    var moment = require('moment');
    require('moment/locale/th');

    //authenticationService.logout();

    const currentUser = authenticationService.currentUserValue;


    //check login
    if (!currentUser) {
        // not logged in so redirect to login page with the return url
        return <Redirect to={{ pathname: '/login', /*state: { from: props.location }*/ }} />
    }

    const onSubmit = values => {
        console.log(JSON.stringify(values));
    };

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <IndexHeader  />
        <div className="main">
                  <div className="section">
                      <Container>
                          <Row>
                              <Col md="2">
                              </Col>
                              <Col md="8">
                                  <div className="hero-images-container " style={{ marginTop: '-20vh', maxWidth:'680px'}}>
                                      <img
                                          alt="..."
                                          src={require("assets/img/ts_logo_xl.png")}
                                      ></img>
                                  </div>
                              </Col>
                              <Col md="2">
                              </Col>
                          </Row>
                      </Container>
                  </div>  
        </div>
        
              <div className="section section-contact-us" style={{padding:0}}>
            <Container>
                      <h3 className="title text-center">นัดหมายปรึกษาทางไกลของคุณ {FullName}</h3>
                      <Row>
                          <Col className="ml-auto mr-auto" lg="6" md="8">
                              <FormGroup
                                  style={{ padding: '0 0px', marginBottom: '10px' }}
                                  className={
                                      "input-lg" + (dateFocus ? " input-group-focus" : "")
                                  }
                              >
                                  <i className="far fa-calendar-check fa-2x" style={{
                                      position: 'absolute',
                                      left: '12px',
                                      top: '15px',
                                      zIndex: 1,
                                    
                                  }}
                                  ></i>
                                  <Datetime
                                      renderYear={function (props, year, selectedDate) { return <td {...props}>{year+543}</td>;}}
                                      isValidDate={e => e.day() !== 0 && e.day() !== 6 && e > (new Date()).setDate((new Date().getDate()-1)) }
                                      inputProps={{
                                          name: "AppointDatetime", placeholder: "วันที่รับบริการ", readOnly: 'readonly', style: {
                                              fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background:'#ffffff', color:'#000000'
                                          }
                                      }}
                                      closeOnSelect={true}
                                      closeOnTab={true}
                                      dateFormat="D MMMM BBBB" timeFormat="เวลา HH:mm น."
                                      onFocus={() => setDateFocus(true)}
                                      onBlur={() => setDateFocus(false)}
                                      onChange={e => setDate(e.format('YYYY-MM-DD HH:mm'))}
                                  />
                                  
                              </FormGroup>


                              <TSSelect isDefault={false} placeholder={"แพทย์ผู้ปรึกษา"} options={parentOption} onChange={e => setParentID(e)} value={parentID} />

                              <div className="textarea-container" style={{ padding: 0 }}>
                                  <Label for="Description">บอกเล่าอาการเบื้องต้น
                                  <Input
                                      id="Description"
                                      cols="80"
                                      name="Description"
                                          placeholder="บอกเล่าอาการเบื้องต้น"
                                      rows="4"
                                      type="textarea"
                                      style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                      onChange={e => setDescription(e.target.value)}
                                      ></Input>
                                  </Label>
                              </div>



                              <div className="text-center">
                                  <Button className={(isOpenCam ? "col-12 col-md-5" : "col-12 col-md-12")}
                                      //block
                                      //className="btn-round"
                                      color={(isOpenCam ? "danger" : "success")}
                                      href="#pablo"
                                      size="lg"
                                      style={{ fontSize: '1.2em' }}
                                      onClick={(isOpenCam ? stopCam : startCam)}
                                  >
                                      {(isOpenCam ? "ปิดกล้อง" : "เปิดกล้อง")}
                                  </Button>
                                  {(isOpenCam) &&
                                      <Button
                                          className="col-12 col-md-5"
                                          //block
                                          //className="btn-round"
                                          color="info"
                                          href="#pablo"
                                          size="lg"
                                          style={{ fontSize: '1.2em' }}
                                          onClick={captureThenClose}
                                      >
                                          Capture
                                  </Button>
                                  }
                              </div>
                           
                                 
                                

                              <div className="camView">
                                {(isOpenCam) &&
                                      <Webcam
                                      style={{
                                          position: 'absolute',left: '-320px',overflow: 'hidden'
                                      }}
                                          audio={false}
                                          ref={webcamRef}
                                          height={720}
                                          width={1280}
                                          screenshotFormat="image/jpeg"
                                          videoConstraints={{
                                              width: 1280,
                                              height: 720,
                                              facingMode: "user"
                                          }}
                                      />
                                }
                              </div>
                              

                              {
                                  (files.length >= 1) ?
                                      <div className="clear-button">
                                          <Button
                                              block
                                              //className="btn-round"
                                              color="danger"
                                              href="#pablo"
                                              size="lg"
                                              style={{ fontSize: '1.2em' }}
                                              onClick={handleClear}
                                          >
                                              ล้างรูปใหม่
                                              </Button>
                                      </div> :
                                      ""
                              }
                              <section className="container text-center" style={{cursor: 'pointer', border: '1px dashed', padding: '20px 0px'}}>
                                  <div {...getRootProps({ className: 'dropzone' })}>
                                      <input /*name="fileUpload"*/ {...getInputProps()} /*onChange={handleChange}*/ />
                                      <p> <i className="now-ui-icons design_image"></i> แนบไฟล์รูปภาพรอยโรค </p>
                                      <p> รูปยาที่ต้องการรับยาต่อเนื่อง (Android เลือกทีละรูป)</p>
                                      <p> {(ServiceType == 1 ? "พบแพทย์ต้องแนบรูปอาการอย่างน้อย 4 รูป" : "")} </p>

                                  </div>
                                  <aside style={thumbsContainer}>
                                      {thumbs}
                                  </aside>
                              </section>





                              <div className="send-button">
                                  <Button
                                      block
                                      className="btn-round"
                                      color="info"
                                      href="#pablo"
                                      size="lg"
                                      style={{ fontSize: '1.2em' }}
                                      onClick={handleSubmit}
                                  >
                                      ลงทะเบียนนัดหมายปรึกษาทางไกล
                                  </Button>


                                  {/* Confirm */}
                                  <Modal
                                      modalClassName="modal-mini modal-info"
                                      toggle={() => setModal2(false)}
                                      isOpen={modal2}
                                  >
                                      <div className="modal-header justify-content-center">
                                          <div className="modal-profile">
                                              <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                          </div>
                                      </div>
                                      <ModalBody>
                                          <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการบันทึกข้อมูล" : "กำลังบันทึกข้อมูล"}</p>
                                          <p>ท่านตรวจสอบที่อยู่จัดส่งถูกต้องแล้วใช่หรือไม่</p>
                                          {/*<h3>{(isCheckedAddress) ? DefAddress : ShippingAddress}</h3>*/}
                                          <p>  </p>
                                      </ModalBody>
                                      <div className="modal-footer">
                                          <Button
                                              className="btn-neutral"
                                              color="link"
                                              type="button"
                                              onClick={() => setModal2(false)}
                                          >
                                              ยกเลิก
                                      </Button>

                                          <Button
                                              className="btn-neutral"
                                              color="link"
                                              type="button"
                                              onClick={handleConfirm}
                                              disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                          //onClick={() => setModal2(false)}
                                          >
                                              ยืนยัน
                                      </Button>



                                      </div>
                                  </Modal>

                                  {/* Finish */}
                                  <Modal
                                      modalClassName="modal-mini modal-success"
                                      toggle={() => {
                                          const { from } = props.location.state || { from: { pathname: "/hospital" } };
                                          props.history.push(from);
                                      }}
                                      isOpen={modalNote}
                                  >
                                      <div className="modal-header justify-content-center">
                                          <div className="modal-profile">
                                              <i className={"far fa-calendar-check"} style={{ color: 'green', fontSize: '2em' }}></i>
                                          </div>
                                      </div>
                                      <ModalBody>
                                          <p>บันทึกข้อมูลสำเร็จ</p>
                                          <p>  </p>
                                      </ModalBody>
                                      <div className="modal-footer" style={{ justifyContent: 'center' }}>
                                          <Button
                                              className="btn-neutral"
                                              color="white"
                                              type="button"
                                              onClick={() => {
                                                  const { from } = props.location.state || { from: { pathname: "/hospital" } };
                                                  props.history.push(from);
                                                }
                                              }
                                          >
                                              ตกลง
                                      </Button>



                                      </div>
                                  </Modal>
                                  {/* Error */}
                                  <Modal
                                      modalClassName="modal-mini modal-danger"
                                      toggle={() => setModalError(false)}
                                      isOpen={modalError}
                                  >
                                      <div className="modal-header justify-content-center">
                                          <div className="modal-profile">
                                              <i className="fa fa-times" style={{ color: 'red', fontSize: '2em' }}></i>
                                          </div>
                                      </div>
                                      <ModalBody>
                                          <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                          <p> {errMsg} </p>
                                      </ModalBody>
                                      <div className="modal-footer justify-content-center">
                                          <Button
                                              className="btn-neutral"
                                              color="neutral"
                                              type="button"
                                              onClick={() => setModalError(false)}
                                          >
                                              ตกลง
                                      </Button>
                                      </div>
                                  </Modal>

                              </div>
                          </Col>
                      </Row>
                  </Container>
        </div>
        <DefaultFooter />
      </div>
    </>
  );
}

export default TelePage2;
